import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class Badge extends AuxiliumComponent {
	static observable = ["variation", "size", "icon", "link", "badge-style"];

	constructor() {
		super();

		this.variation ??= "theme";
	}

	parsedCallback() {
		if (this.link) { this.appendChild(document.createElementWithContents("chip-link", this.childNodes, { href: Browser.ResolveRelativeURL(this.link) })); }

		this.classList.add("badge", `badge--${this.variation}`);

		if (this.size) { this.classList.add(`badge--${this.size.toLowerCase()}`); }
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
	}

	SetText(text) {
		this.textContent = text;
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
	}

	attributeChanged(name, oldValue, newValue) {
		if (name === "variation") {
			this.classList.remove(`badge--${oldValue}`);
			this.classList.add(`badge--${newValue}`);
		}
	}
}
